/**
 * Centralized displayId utility.
 * Derives a short, human-friendly ID from publicId (preferred) or id fallback.
 * - Accepts entity-like objects with optional publicId/public_id/id, or a string id directly.
 * - Trims and slices to the specified length (default 6).
 */
export function getDisplayId(
  input: unknown,
  length = 6
): string {
  try {
    const len = Number.isFinite(length) && length! > 0 ? (length as number) : 6;

    // If input is a primitive string/number, use it directly
    if (typeof input === 'string' || typeof input === 'number') {
      const s = String(input).trim();
      return s.length > 0 ? s.substring(0, len) : '';
    }

    if (input && typeof input === 'object') {
      const obj = input as Record<string, unknown>;
      const raw =
        (obj.publicId as string | undefined) ??
        (obj.public_id as string | undefined) ??
        (obj.id as string | undefined);
      const s = (raw ?? '').toString().trim();
      return s.length > 0 ? s.substring(0, len) : '';
    }

    return '';
  } catch {
    return '';
  }
}
